<script lang="ts">
  import { app } from './appState.svelte';
</script>

{#if app.toast}
  <div class="toast">
    <span>{app.toast.message}</span>
    {#if app.toast.undo}
      <button onclick={async () => { const t = app.toast; app.toast = null; if (t?.undo) await t.undo(); }}>Undo</button>
    {/if}
  </div>
{/if}

<style>
  .toast { position: fixed; bottom: calc(24px + env(safe-area-inset-bottom)); left: 50%; transform: translateX(-50%); background: var(--ink-primary); color: var(--paper); border-radius: var(--radius-panel); padding: 12px 16px; display: flex; gap: 14px; align-items: center; box-shadow: var(--shadow-soft); z-index: 60; font-size: 13px; }
  button { background: none; border: none; color: var(--accent); font-weight: 700; cursor: pointer; }
</style>
